/* LRC Bundle Builder - script copied verbatim from
   ~/Downloads/lrc-bundle-builder-v5.html <script> block (lines 334-664).
   Changes: (a) DOM queries scoped to the .lrc-bb root; (b) the five dev-panel
   bindings null-guarded because the section omits the mockup's .dev strip.
   Phase 2: CFG now reads window.LRC_BB_CFG; pricing uses the real selling-plan
   allocation instead of a flat percentage; sq() renders the variant image. */
(function(){
  var ROOT = document.querySelector('.lrc-bb');
  if (!ROOT) return;
/* Derived in the real build from variant.price, the selling plan allocation,
   lrc.total_servings, lrc.unit_label, lrc.units_per_bag, lrc.pack_options.
   Tint, badge and detail copy are theme-editor settings. */
const CFG = window.LRC_BB_CFG;
if (!CFG || !CFG.verticals || !CFG.verticals.length) return;

/* qty stores PACKS. units = packs × packQty × upb */
let qty={},gift=null,step=0,dir='fwd',prevShip=false,prevGift=false,lastChips='';
/* set when a step is entered from a review Edit link; the advance button then
   returns to review instead of walking forward. Cleared on use and on any
   navigation that is not the advance button. */
let editReturn=false;
/* per-tile option-2 selection, keyed exactly like qty. Index into it.opts. */
let optSel={};
/* the option a tile is currently set to. Falls back to the item itself when the
   vertical has no second option, so every price read has one shape. */
const pick=(v,it,i)=>{
  const o=it.opts;
  if(!o||!o.length)return it;
  return o[optSel[v.id+'-'+i]]||o[it.optDef]||o[0];
};
/* the {vertical,item,index} behind a qty/optSel key. Scans rather than splitting
   on '-' so it stays correct whatever a vertical id contains. */
const byKey=k=>{
  for(const v of CFG.verticals)for(let i=0;i<v.items.length;i++)
    if(v.id+'-'+i===k)return{v,it:v.items[i],i};
  return null;
};
/* true when the sole choosable gift was selected for the visitor rather than by
   them, so dropping below the threshold clears it without discarding a real choice. */
let giftAuto=false;
const $=s=>ROOT.querySelector(s),$$=s=>[...ROOT.querySelectorAll(s)];
const money=n=>'$'+n.toFixed(2);
const packQty=(v,it)=>it.single?1:v.packQty;
function resetQty(){qty={};optSel={};CFG.verticals.forEach(v=>v.items.forEach((it,i)=>{
  qty[v.id+'-'+i]=CFG.prefill?it.pre:0;
  optSel[v.id+'-'+i]=it.optDef||0;
}));}
resetQty();

const half=()=>CFG.reward==='half';
/* price defaults to the item's own (the default option); callers with a key pass
    the selected option's price so every figure follows the toggle. */
const perServ=(it,price)=>it.servings>0?(price==null?it.price:price)/it.servings:0;
const perServK=(v,it,i)=>perServ(it,pick(v,it,i).price);
/* the vertical header quotes the CHEAPEST option, not the default */
const perServMin=it=>{
  if(!it.opts||!it.opts.length)return perServ(it);
  return Math.min(...it.opts.map(o=>perServ(it,o.price)));
};
const minOf=v=>CFG.plan90?v.min90:v.min30;
const vertUnits=v=>v.items.reduce((s,it,i)=>s+qty[v.id+'-'+i]*packQty(v,it)*it.upb,0);
function msrp(){let t=0;CFG.verticals.forEach(v=>v.items.forEach((it,i)=>t+=qty[v.id+'-'+i]*packQty(v,it)*pick(v,it,i).msrp));return t;}
const sub=()=>{let t=0;CFG.verticals.forEach(v=>v.items.forEach((it,i)=>t+=qty[v.id+'-'+i]*packQty(v,it)*pick(v,it,i).price));return t;};
const payable=()=>half()&&giftOK()?msrp()*.5:sub();
const packs=()=>Object.values(qty).reduce((a,b)=>a+b,0);
/* what the bag badge shows — includes the gift once it is unlocked and chosen */
const bagCount=()=>packs()+wonGifts().length;
const shipOK=()=>sub()>=CFG.freeShip;
const giftOK=()=>sub()>=CFG.giftAt;
/* --- gift modes ---------------------------------------------------------
   'always' gifts are included whenever their own threshold is met (0 = always)
   and are never selectable. 'choose' gifts are the original one-of-N group,
   gated on the section-level CFG.giftAt. `gift` stays an index into CFG.gifts. */
/* THREE modes now. 'recurring' is a SUBSCRIPTION line - added with the section's
   selling plan and zeroed on cycle one by its OWN code (recurringCycleLimit 1), so
   it bills at the normal subscriber price from cycle two. In the box maths it is
   free, exactly like the others.
   Every gating question in this file is "auto-included or chosen?", never "always
   or not", so isAuto is the predicate the rest of the code uses; isRecurring is
   consulted only where a selling plan or a code is at stake. */
const isRecurring=g=>g.mode==='recurring';
const isAuto=g=>g.mode==='always'||g.mode==='recurring';
const chooseGifts=()=>CFG.gifts.map((g,i)=>({g,i})).filter(x=>!isAuto(x.g));
const alwaysQualified=()=>CFG.gifts.map((g,i)=>({g,i})).filter(x=>isAuto(x.g)&&sub()>=(+x.g.threshold||0));
/* every gift currently in the box */
const wonGifts=()=>{if(half())return[];
  const l=alwaysQualified().map(x=>x.g);
  const c=gift!==null?CFG.gifts[gift]:null;
  if(c&&!isAuto(c)&&giftOK())l.push(c);
  return l;};
const giftRow=g=>`<div class="li freeline">${sq(g.tint,'box',g.img)}<div class="li-mid">${g.n}</div><div class="li-q">Free</div></div>`;
const rewardName=()=>half()?'50% off your first box':'free gear';

function buildSteps(){const s=[];if(CFG.showIntro)s.push({type:'intro'});
  CFG.verticals.forEach(v=>s.push({type:'vert',v}));
  if(!half()&&CFG.gifts&&(chooseGifts().length||alwaysQualified().length))s.push({type:'gift'});s.push({type:'review'});return s;}
let STEPS=buildSteps();

const shade=(h,p)=>{const n=parseInt(h.slice(1),16),f=x=>Math.max(0,Math.min(255,x+p));
  return '#'+((1<<24)+(f(n>>16)<<16)+(f(n>>8&255)<<8)+f(n&255)).toString(16).slice(1);};
/* Every builder image URL is emitted by Liquid as `image_url: width: 384`, so the
   24px placeholder is the same URL with the width swapped. The swap is guarded: if
   the string did not change we emit NO placeholder rather than risk requesting an
   un-resized original, which is 3.6-7.1 MB.
   The placeholder's URL is parked in data-lo, NOT in src. Nothing in the builder may
   fetch at page load, and an eager <img> with a real src fetches even inside a
   display:none subtree - lazy loading is what display:none suppresses, eager is not.
   afterPaint() assigns the src, and only for the step actually on screen. */
const loURL=u=>{const l=u.replace(/([?&])width=384(?=&|$)/,'$1width=24');return l===u?'':l;};
const sq=(tint,shape='',img='')=>{
  const lo=img?loURL(img):'';
  return `<div class="sq" style="background:linear-gradient(155deg,${shade(tint,26)},${tint})">`+
    (img?`${lo?`<img class="sq-lo" data-lo="${lo}" alt="" aria-hidden="true" width="24" height="24" loading="eager" decoding="async">`:''}`+
      `<img class="sq-hi" src="${img}" alt="" width="384" height="384" loading="lazy" decoding="async" onload="this.classList.add('rdy');this.parentNode.classList.add('sq-on')" onerror="this.parentNode.classList.add('sq-on')" style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover;display:block">`
     :`<div class="prod ${shape}"></div>`)+`</div>`;
};

const introStep=()=>`
  <p class="eyebrow"><span class="beacon"></span>Before you start</p>
  <h2 class="hiw-h">How this works</h2>
  <div class="hiw">
    <div class="hiw-row" data-hiw role="button" tabindex="0"><span class="hiw-n">1</span><div><b>Pick your flavours</b><span>Pouches, coffee and tea — three quick screens</span></div></div>
    <div class="hiw-row" data-hiw role="button" tabindex="0"><span class="hiw-n">2</span><div><b>Watch the bar fill</b><span>Free shipping first, then ${rewardName()}</span></div></div>
    <div class="hiw-row" data-hiw role="button" tabindex="0"><span class="hiw-n">3</span><div><b>Check out</b><span>Arrives in 2–4 days, ${CFG.plan90?'every 90 days':'every 30 days'} after that</span></div></div>
  </div>
  ${offerHero()}`;

/* condition badge for an intro gear card. Reuses the flavour tile's .badge
   treatment (navy pill, top-left, over the image). Labels are settings read from
   the root; {amount} is substituted here, never inside a Liquid string. */
function giftBadge(g){
  if(!CFG.gifts.includes(g))return '';
  /* an 'always' gift is gated by its own threshold (0 = unconditional);
     a 'choose' gift is gated by the section-level CFG.giftAt. */
  const t=isAuto(g)?(+g.threshold||0):(+CFG.giftAt||0);
  const a=ROOT.getAttribute('data-gift-always-label')||'';
  const gd=ROOT.getAttribute('data-gift-gated-label')||'';
  const txt=t>0?gd.replace('{amount}',money(t)):a;
  return txt?`<span class="badge">${txt}</span>`:'';
}
function offerHero(){
  const h=CFG.hero[CFG.reward]; if(!h) return '';
  const cards=h.cards==='gifts'?CFG.gifts:(h.cards||[]);
  const hasStmt=!!h.stmt, hasCards=cards.length>0;
  if(!hasStmt&&!hasCards) return '';
  return `<div class="unlocks">
    <p>${h.eyebrow}</p>
    ${hasStmt?`<div class="stmt">${h.stmt}${h.stmtSub?`<small>${h.stmtSub}</small>`:''}</div>`:''}
    ${hasCards?`<div class="urow${hasStmt?' tight':''}">
      ${cards.map(g=>`<div class="ucard">${sq(g.tint,'box',g.img)}${giftBadge(g)}<div class="ub"><b>${g.n}</b><i>Free</i></div></div>`).join('')}
    </div>`:''}
  </div>`;
}

/* option toggle. Markup copied from ~/Downloads/lrc-grind-toggle-v4.html:
   two <button> segments in .grind, or .grind.one with a single <span> label when
   only one option is available. CSS hides .t-serv.swap and shows .grind on a
   selected tile, so the tile height is unchanged either way. */
function optRow(v,it,i,k){
  const o=it.opts;
  if(!o||!o.length)return '';
  if(o.length===1)return `<div class="grind one"><span>${o[0].v}</span></div>`;
  const sel=optSel[k]==null?(it.optDef||0):optSel[k];
  return `<div class="grind">${o.map((x,n)=>
    `<button class="${n===sel?'sel':''}" data-optk="${k}" data-optv="${n}">${x.v}</button>`).join('')}</div>`;
}
function vertStep(v,vi){
  const tiles=v.items.map((it,i)=>{
    const k=v.id+'-'+i,q=qty[k],pq=packQty(v,it);
    return `<div class="tile${q>0?' active':''}" data-tile="${k}" style="animation-delay:${i*45}ms">
      ${CFG.badges&&it.badge?`<span class="badge">${it.badge}</span>`:''}
      <button class="info" data-info="${vi}-${i}" aria-label="About ${it.n}">i</button>
      ${sq(it.tint,it.single?'box':v.shape,it.img)}
      <div class="tile-b">
        <div class="t-label">${it.n}</div>
        <div class="t-serv swap">${money(perServK(v,it,i))} <span>/ ${v.unit}</span></div>
        ${optRow(v,it,i,k)}
        ${pq>1?`<div class="packnote">${v.packLabel}</div>`:''}
        <div class="stepper">
          <button data-q="${k}" data-d="-1" ${q===0?'disabled':''} aria-label="Remove">−</button>
          <span data-n="${k}">${q}</span>
          <button data-q="${k}" data-d="1" aria-label="Add">+</button>
        </div>
      </div></div>`;}).join('');
  const min=minOf(v);
  return `<p class="eyebrow"><span class="beacon"></span>${min>0?`Pick at least ${min} ${v.count}${min>1?'s':''}`:'Optional'}</p>
    <h2 class="step-h">${v.title}</h2>
    <p class="step-s">${v.subtitle||(v.why&&v.why.p?v.why.p.split('.')[0]+'.':'')}</p>
    ${v.why&&v.why.h?`<button class="whylink" data-why="${vi}"><em>?</em>${v.why.h}</button>`:''}
    <div class="grid">${tiles}</div>`;
}

function giftStep(){
  const ok=giftOK(),gap=CFG.giftAt-sub();
  const ri=STEPS.findIndex(s=>s.type==='vert'&&s.v.id===CFG.gapRoute);
  const rn=(CFG.verticals.find(v=>v.id===CFG.gapRoute)||{}).title||'';
  const inc=alwaysQualified(),ch=chooseGifts();
  /* Always-included gifts get their own card, matching .rev-group - the same
     white/border/radius panel the review step uses for its groups, with a
     .rev-head heading bar and a .rev-body list. The heading carries no FREE
     line of its own - each row already shows it. Previously these rows used
     .rev-body on its own, outside the container it is padded for, which is why
     they read as bare rows. Renders only when at least one always-gift
     qualifies; otherwise nothing is emitted. */
  const incHd=ROOT.getAttribute('data-gift-included-heading')||'Already included';
  const strip=inc.length?`<div class="rev-group" style="margin-top:16px"><div class="rev-head">
      <div class="rh-l"><b>${incHd}</b></div></div>
      <div class="rev-body">${inc.map(x=>giftRow(x.g)).join('')}</div></div>`:'';
  const grid=ch.length?`<div class="${ok?'':'locked'}"><div class="gifts">
      ${ch.map(x=>`<div class="gift${gift===x.i?' active':''}" data-gift="${x.i}">${sq(x.g.tint,'box',x.g.img)}<div class="gb"><b>${x.g.n}</b><i>${money(x.g.v)} value</i></div></div>`).join('')}
    </div></div>
    ${ok?'':`<div class="lockbar"><div><b>${money(gap)} away</b><span>Add more to unlock free gear</span></div>
      <button data-goto="${ri}">Add ${rn.split(' ').pop()}</button></div>`}`:'';
  return `<p class="eyebrow"><span class="beacon"></span>${ch.length?(ok?'Choose your gear':'Almost there'):'Included with your box'}</p>
    <h2 class="step-h">${ch.length?'Pick your free gear':'Your free gear'}</h2>
    <p class="step-s" style="margin-bottom:18px">${ch.length&&!ok?'Add a little more and one of these is yours.':'Yours to keep, whatever you do next.'}</p>
    ${grid}${strip}`;
}

/* The option label appears for EVERY item that has options, the default included.
   It used to be suppressed at opts.length>1, which hid the label on a flavour with
   only one buyable option (coffee's Medium and Light, whose Whole Bean is out of
   stock) - and an absent label then read the same as pouches, which have no options
   at all. Items with no options still show nothing. */
const lineItem=(it,q,v,i)=>{const pq=packQty(v,it);
  const o=(it.opts&&it.opts.length&&i!=null)?pick(v,it,i):null;
  const tag=[o?o.v:'',pq>1?v.packLabel:''].filter(Boolean).join(' · ');
  return `<div class="li">${sq(it.tint,it.single?'box':v.shape,it.img)}
    <div class="li-mid">${it.n}${tag?`<em>${tag}</em>`:''}</div><div class="li-q">×${q}</div></div>`;};

function totalsBlock(){
  const ok=giftOK(),ship=shipOK(),sc=ship?0:7.99;
  const won=wonGifts(),gearV=won.reduce((a,g)=>a+(+g.v||0),0);
  const pay=payable()+sc, wouldBe=msrp()+7.99+gearV;
  const dLabel=half()&&ok?'First box 50% off':'Your discount (25%)';
  const dAmt=half()&&ok?msrp()-payable():msrp()-sub();
  return `<div class="totals">
    <div class="trow win"><span>${dLabel}</span><span>−${money(dAmt)}</span></div>
    ${won.map(g=>`<div class="trow win"><span>${g.n}</span><span>−${money(g.v)}</span></div>`).join('')}
    <div class="trow ${ship?'win':''}"><span>Shipping</span><span>${ship?'−'+money(7.99):money(7.99)}</span></div>
    <div class="trow grand"><span>Total today</span>
      <span class="grandval"><s>${money(wouldBe)}</s><b>${money(pay)}</b></span></div>
    <div class="savechip"><span>You save today</span><u>${money(wouldBe-pay)}</u></div>
  </div>`;
}

function reviewStep(){
  const groups=CFG.verticals.map(v=>{
    const idx=STEPS.findIndex(s=>s.type==='vert'&&s.v.id===v.id);
    const picked=v.items.filter((_,i)=>qty[v.id+'-'+i]>0);
    const lines=v.items.map((it,i)=>qty[v.id+'-'+i]?lineItem(it,qty[v.id+'-'+i],v,i):'').join('');
    const cheap=picked.length?Math.min(...picked.map(it=>perServMin(it))):0;
    return `<div class="rev-group"><div class="rev-head">
      <div class="rh-l"><b>${v.title}</b>${picked.length?`<span>${money(cheap)} / ${v.unit}</span>`:''}</div>
      <button data-goto="${idx}" data-edit>Edit</button></div>
      ${lines?`<div class="rev-body">${lines}</div>`:'<div class="rev-empty">Nothing selected</div>'}</div>`;}).join('');
  const gi=STEPS.findIndex(s=>s.type==='gift'),won=wonGifts();
  const gb=won.length?`<div class="rev-group"><div class="rev-head">
      <div class="rh-l"><b>Free gear</b><span>Free</span></div>${gi>=0?`<button data-goto="${gi}" data-edit>Edit</button>`:''}</div>
      <div class="rev-body">${won.map(giftRow).join('')}</div></div>`:'';
  return `<p class="eyebrow"><span class="beacon"></span>Review</p>
    <h2 class="step-h">Here's your box</h2>
    <p class="step-s" style="margin-bottom:18px">Arrives in 2–4 days, then ${CFG.plan90?'every 90 days':'every 30 days'}. Skip or cancel anytime.</p>
    ${groups}${gb}${totalsBlock()}`;
}

function render(){
  STEPS=buildSteps();if(step>STEPS.length-1)step=STEPS.length-1;
  const host=$('#steps');host.innerHTML='';
  STEPS.forEach((st,i)=>{
    const el=document.createElement('div');
    el.className='step'+(i===step?' on':'')+(dir==='back'?' back':'');
    el.innerHTML=st.type==='intro'?introStep():st.type==='vert'?vertStep(st.v,CFG.verticals.indexOf(st.v)):st.type==='gift'?giftStep():reviewStep();
    host.appendChild(el);
  });
  $('#offerLine').innerHTML=half()?'Save 50% on your first box <i>·</i> Free shipping':'Save 25% <i>·</i> Free gear <i>·</i> Free shipping';
  wireStep();syncAll();$('#mbody').scrollTop=0;
  $('#prog').classList.toggle('hide',STEPS[step].type==='intro');
  afterPaint();
}

/* ---- image performance -------------------------------------------------
   Every step is built into the DOM on each render and hidden with
   .step{display:none}. A display:none image with loading="lazy" never
   fetches, so each step used to start downloading only at the moment it
   became visible. Three things happen here:
     1. the CURRENT step's images are promoted to eager so they fetch now;
     2. any image already complete (cache, or load fired before this ran)
        is marked .rdy synchronously so the fade can never strand it at 0;
     3. the NEXT step's URLs are warmed at idle, once per session.        */
const warmed=new Set();
function warmStep(i){
  const st=STEPS[i]; if(!st)return;
  let urls=[];
  if(st.type==='vert')urls=(st.v.items||[]).map(x=>x.img);
  else if(st.type==='gift')urls=(CFG.gifts||[]).map(g=>g.img);
  urls.forEach(u=>{
    if(!u||warmed.has(u))return;
    warmed.add(u);
    try{const im=new Image();im.decoding='async';im.src=u;}catch(e){}
  });
}
/* The current render's generation. Every timer and poller below carries the value it
   was started with and gives up if a later render has replaced the DOM it was
   watching, so step changes cannot pile up pollers or fetch into detached nodes. */
let paintGen=0;
/* Wait for a set of images to reach a TERMINAL state, then call back.
   Polling .complete rather than listening for load/error, deliberately:
   .complete is true after a success, true after an error, AND already true for an
   image served from cache before any listener could be attached. One predicate
   covers all three, so there is no missed-event case - a load listener attached to
   an already-finished image never fires, and the warm would hang forever.
   .complete alone still cannot describe a request that never terminates (a stalled
   socket, a hung proxy), so a hard cap releases the warm regardless. Between the two,
   there is no path on which the next step goes un-warmed. */
function whenSettled(imgs,gen,cb){
  if(!imgs.length){cb();return;}
  const t0=Date.now(),CAP=4000;
  (function tick(){
    if(gen!==paintGen)return;
    if(imgs.every(im=>im.complete)||Date.now()-t0>CAP){cb();return;}
    setTimeout(tick,60);
  })();
}
function afterPaint(){
  const gen=++paintGen;
  /* render() runs once at page load to build the shell, so everything costly
     below is gated on the modal actually being open. While #scrim lacks .open
     the whole subtree is display:none, every image is loading="lazy", and
     nothing is fetched. This single guard covers BOTH costly behaviours:
       (a) promoting the current step's images to eager, and
       (b) warming the next step's URLs.
     The [data-open] handler adds .open BEFORE calling render(), so both run
     on the first tap. */
  if(!$('#scrim').classList.contains('open'))return;
  try{
    const cur=$('#steps').children[step];
    if(cur)[...cur.querySelectorAll('img[loading="lazy"]')].forEach(im=>{im.loading='eager';});
    [...$('#steps').querySelectorAll('.sq img.sq-hi')].forEach(im=>{
      if(im.complete&&im.naturalWidth){im.classList.add('rdy');im.parentNode.classList.add('sq-on');}
    });
    /* Placeholders, for the visible step only.
       THE CACHED-IMAGE RACE: a real image already in cache is not reported by
       .complete on the tick its src is assigned - the fetch resolves a task later. So
       the sweep above cannot catch it on a first render, and giving the placeholder a
       src immediately would fetch 2.5 KB and paint a blur over an image that was about
       to appear anyway. Instead the src is assigned on a short delay and only if the
       real image has still not arrived. A cache hit fires onload well inside that
       window, gains .rdy, and its placeholder is never requested at all - not merely
       hidden. On a cold open the real image cannot possibly be back within LO_WAIT
       (measured warm TTFB is 85-150 ms), so the placeholder always starts.
       isConnected guards against a render having replaced the tile meanwhile. */
    const LO_WAIT=60;
    if(cur)[...cur.querySelectorAll('img.sq-lo[data-lo]')].forEach(lo=>{
      const parent=lo.parentNode;
      setTimeout(()=>{
        if(gen!==paintGen||!lo.isConnected||lo.getAttribute('src'))return;
        if(parent.classList.contains('sq-on'))return;
        lo.src=lo.getAttribute('data-lo');
      },LO_WAIT);
    });
  }catch(e){}
  const run=()=>{try{
    /* A warm scheduled by an EARLIER render must not fire. whenSettled() can call
       back synchronously (a step with no images, i.e. the intro), which only queues
       run() at idle - and by the time idle arrives the visitor may already have
       advanced. Without this guard that stale callback resolves `nxt` against the NEW
       step and warms the step after the visible one, which is exactly the competition
       this change exists to remove. Measured: it started the 178 KB coffee warm 11 ms
       into the pouches step, before a single pouch tile had finished. */
    if(gen!==paintGen)return;
    const nxt=STEPS[step].type==='intro'?STEPS.findIndex(s=>s.type==='vert'):step+1;
    if(nxt>0&&nxt<STEPS.length)warmStep(nxt);
  }catch(e){}};
  /* The next step's tiles used to start downloading the moment this step painted -
     178 KB of speculative coffee racing 137 KB of visible pouches on one connection.
     The warm now waits until every image on THIS step has settled. A step with no
     images (the intro) settles instantly and warms exactly as before. */
  let hi=[];
  try{const c=$('#steps').children[step];if(c)hi=[...c.querySelectorAll('img.sq-hi')];}catch(e){}
  whenSettled(hi,gen,()=>{
    if(window.requestIdleCallback)requestIdleCallback(run,{timeout:1200});else setTimeout(run,300);
  });
}

function touch(k){
  const tile=ROOT.querySelector(`[data-tile="${k}"]`),n=ROOT.querySelector(`[data-n="${k}"]`),q=qty[k];
  if(n){n.textContent=q;n.classList.add('tick');setTimeout(()=>n.classList.remove('tick'),200);}
  if(tile){tile.classList.toggle('active',q>0);
    const m=tile.querySelector('[data-d="-1"]');if(m)m.disabled=q===0;}
  syncAll();
}

/* Surgical option switch - touch()'s counterpart for the toggle.
   render() empties #steps and rebuilds every step, so each tile becomes a NEW
   element and re-runs .tile's lrcbb-tileIn entry animation on its inline
   animation-delay stagger - the whole grid flashes. Nothing about the layout
   changes when an option is switched, so nothing needs rebuilding: only the two
   segments' selected state and, for the tile that changed, its per-serving.
   .t-serv is display:none while the tile is active (the toggle occupies the same
   line) but it is updated regardless, so it is already correct if the stepper
   later takes the tile back to zero.
   Everything downstream - totals, thresholds, gift auto-select, cart, review
   button, sticky bar, bag count, progress, advance - is syncAll(), the very call
   touch() makes. Nothing is recomputed here. */
function touchOpt(k){
  const tile=ROOT.querySelector(`[data-tile="${k}"]`),r=byKey(k);
  if(tile){
    tile.querySelectorAll('[data-optv]').forEach(b=>
      b.classList.toggle('sel',+b.dataset.optv===optSel[k]));
    const s=tile.querySelector('.t-serv');
    if(s&&r)s.innerHTML=`${money(perServK(r.v,r.it,r.i))} <span>/ ${r.v.unit}</span>`;
  }
  syncAll();
}

/* cumulative fill toward the current threshold */
function goalState(){
  const s=sub();
  if(!shipOK())return{pct:s/CFG.freeShip*100,text:`<b>${money(CFG.freeShip-s)}</b> to free shipping`,idle:packs()===0};
  if(!giftOK())return{pct:s/CFG.giftAt*100,text:`<b>${money(CFG.giftAt-s)}</b> to ${rewardName()}`,idle:false};
  return{pct:100,text:'',idle:false,all:true};
}
function chipsHTML(){let h='';
  if(shipOK())h+='<span class="chip">✓ Free shipping</span>';
  if(giftOK())h+=`<span class="chip">✓ ${half()?'50% off':'Free gear'}</span>`;return h;}

/* Auto-select the sole choosable gift once the box qualifies. Runs from
   syncAll(), so it applies the moment the threshold is crossed - not only when
   the gift step is reached. Three conditions, all required:
     exactly one CHOOSE gift · the box qualifies · no selection made yet.
   With two or more choosable gifts nothing is selected; the choice stays deliberate. */
function autoGift(){
  if(half())return;
  const ch=chooseGifts();
  if(ch.length!==1){ if(giftAuto){gift=null;giftAuto=false;} return; }
  if(giftOK()){
    if(gift===null){gift=ch[0].i;giftAuto=true;}
  }else if(giftAuto){
    /* dropped below the threshold - clear ours so it is never counted or shown */
    gift=null;giftAuto=false;
  }
}
function syncAll(){
  autoGift();
  /* the gift tiles are built during render(), which calls syncAll() last - so an
     auto-selection made just now would not be reflected in their markup. Sync the
     active class directly, the same thing the tap handler does. */
  $$('[data-gift]').forEach(x=>x.classList.toggle('active',+x.dataset.gift===gift));
  const g=goalState(),n=packs(),ch=chipsHTML(),changed=ch!==lastChips;
  [['#fill','#chips','#goal'],['#cpFill','#cpChips','#cpGoal']].forEach(([f,c,x])=>{
    $(f).style.width=Math.min(100,g.pct)+'%';
    if(changed){$(c).innerHTML=ch;$$(c+' .chip').forEach(el=>el.classList.add('new'));}
    $(x).innerHTML=g.idle?'Add items to unlock free shipping':g.text;
    $(x).classList.toggle('idle',g.idle);
  });
  lastChips=ch;
  $('#prog').classList.toggle('done',!!g.all);
  $('#cpProg').classList.toggle('done',!!g.all);
  if(shipOK()&&!prevShip){$('#fill').classList.add('pop');setTimeout(()=>$('#fill').classList.remove('pop'),1000);toast('<u>✓</u> Free shipping unlocked');}
  if(giftOK()&&!prevGift){$('#fill').classList.add('pop');setTimeout(()=>$('#fill').classList.remove('pop'),1000);toast(`<u>✓</u> ${half()?'50% off unlocked':'Free gear unlocked'}`);}
  prevShip=shipOK();prevGift=giftOK();

  const c=$('#cartCount'),bc=bagCount();
  if(c.textContent!==String(bc)){c.textContent=bc;c.classList.toggle('zero',bc===0);
    $('#cartBtn').classList.add('jolt');setTimeout(()=>$('#cartBtn').classList.remove('jolt'),460);}

  $('#dots').innerHTML=STEPS.map((_,i)=>`<button class="dot${i<step?' done':''}${i===step?' now':''}" data-dot="${i}"></button>`).join('');
  $$('[data-dot]').forEach(d=>d.onclick=()=>{if(+d.dataset.dot<=step){editReturn=false;go(+d.dataset.dot);}});

  const st=STEPS[step],adv=$('#advance'),was=adv.disabled;
  const w=['','one','two','three','four','five','six','seven','eight','nine','ten'];
  adv.disabled=false;
  if(st.type==='intro')adv.textContent='Start building';
  else if(st.type==='vert'){
    const need=Math.max(0,minOf(st.v)-vertUnits(st.v));
    if(need>0){adv.textContent=`Add ${w[need]||need} more`;adv.disabled=true;}
    else adv.textContent=editReturn?'Back to review':(minOf(st.v)===0?'Next':'Continue');
  }else if(st.type==='gift')adv.textContent=editReturn?'Back to review':'Continue';
  else adv.textContent=`Checkout · ${money(payable()+(shipOK()?0:7.99))}`;
  if(was&&!adv.disabled){adv.classList.add('just');setTimeout(()=>adv.classList.remove('just'),520);}

  $('#back').hidden=step===0;
  renderCart();
  syncSticky2();
}

/* ---- sticky CTA bar ---------------------------------------------------
   State comes entirely from the builder's own helpers - packs(), minOf(),
   vertUnits(), bagCount(), payable(), shipOK() - nothing is recomputed. */
const stickyBag=()=>{
  if(half())return packs();
  const g=gift!==null?CFG.gifts[gift]:null;
  return packs()+((g&&!isAuto(g)&&giftOK())?1:0);
};
function stickyState(){
  const short=CFG.verticals.filter(v=>minOf(v)>0&&vertUnits(v)<minOf(v));
  if(packs()===0)return{k:'empty',short:short};
  return short.length?{k:'incomplete',short:short}:{k:'complete',short:short};
}
function syncSticky2(){
  const bar=$('[data-bbx-sticky]');if(!bar)return;
  const st=stickyState();
  const cta=bar.querySelector('[data-bbx-stickycta]');
  const bagn=bar.querySelector('[data-bbx-bagn]');
  const T=k=>bar.getAttribute('data-label-'+k)||'';
  let label,spec='';
  if(st.k==='empty'){ label=T('empty')||'Build Your Box'; }
  else if(st.k==='incomplete'){
    spec='first-gap';
    if(st.short.length===1){
      const v=st.short[0],n=minOf(v)-vertUnits(v);
      label=(T('incomplete')||'Add {n} more {noun}')
        .replace('{n}',n).replace('{noun}',v.count+(n>1?'s':''));
    } else label=T('finish')||'Finish Your Box';
  } else {
    spec='review';
    label=(T('complete')||'Review Your Box · {total}')
      .replace('{total}',money(payable()+(shipOK()?0:7.99)));
  }
  if(cta){cta.textContent=label;
    if(spec)cta.setAttribute('data-open-step',spec);else cta.removeAttribute('data-open-step');}
  /* sticky bag: packs plus only the CHOSEN gift. Always-gifts are excluded here
     because they are not visible on the page - counting them makes an empty box
     read 1. bagCount() is left alone; inside the modal the gift IS shown. */
  if(bagn){const c=stickyBag();bagn.textContent=c;bagn.classList.toggle('zero',c===0);}
}
/* sticky bag -> open the builder, then its cart panel.
   Sequencing: openCart() adds .hidden to #close and .open to #cartPanel, both of
   which assume the modal is already up, so openBuilder() must run first.
   openBuilder() and the render() inside it are synchronous, so #cpBody is already
   populated by the time openCart() runs - no rAF or timeout needed.
   Empty box: open the builder at the intro and do NOT open the panel. A panel
   reading "Your box is empty" is a dead end; the intro is the way forward, and it
   matches what the sticky CTA does with an empty box.
   Reuses openCart() - no second path to the cart panel. */
(function(){
  const sb=$('[data-bbx-bag]'); if(!sb)return;
  sb.onclick=()=>{
    const hasItems=stickyBag()>0;
    openBuilder(hasItems?String(step):null);   /* keep their place, or start at 0 */
    if(hasItems)openCart();
  };
})();

/* reveal once the buy box CTA leaves the viewport */
(function(){
  const bar=$('[data-bbx-sticky]'),anchor=$('#ctaBtn');
  if(!bar||!anchor||!('IntersectionObserver' in window))return;
  new IntersectionObserver(function(es){
    bar.hidden=es[0].isIntersecting;
  },{threshold:0}).observe(anchor);
})();

function renderCart(){
  let h='';
  CFG.verticals.forEach(v=>{
    const picked=v.items.filter((_,i)=>qty[v.id+'-'+i]>0);
    if(!picked.length)return;
    const lines=v.items.map((it,i)=>qty[v.id+'-'+i]?lineItem(it,qty[v.id+'-'+i],v,i):'').join('');
    const cheap=Math.min(...picked.map(it=>perServMin(it)));
    h+=`<div class="vhead"><b>${v.title}</b><i>${money(cheap)} / ${v.unit}</i></div>${lines}`;
  });
  const wonC=wonGifts();
  if(wonC.length)h+=`<div class="vhead"><b>Free gear</b></div>`+wonC.map(giftRow).join('');
  $('#cpBody').innerHTML=h||'<div class="rev-empty" style="padding:28px 0">Your box is empty. Start picking flavours.</div>';
  const foot=$('#cpFoot');
  foot.innerHTML=packs()?totalsBlock():'';
  /* Route out of the cart panel to the review step - deliberately NOT to checkout:
     review carries the free gear, the savings and the struck total, and skipping it
     skips the value stack.
     Qualification is stickyState().k === 'complete', the SAME call the sticky bar
     makes, so "finished box" has exactly one definition (packs()>0 AND every
     vertical with minOf(v)>0 has met it). A vertical with a minimum of 0 is not
     in that filter, so it can never block.
     ABSENT, not disabled: the cart panel is a summary, and a dead control in it
     states a rule the panel does not explain - the progress bar and the advance
     button already say what is missing, in the place the visitor has to go anyway.
     A disabled button here would be the third voice on the same subject. */
  if(stickyState().k==='complete'){
    const b=document.createElement('button');
    b.className='cp-review';b.id='cpReview';b.type='button';
    b.textContent=ROOT.getAttribute('data-cart-review-label')||'Review your box';
    /* go() closes the panel itself before it re-renders, so the sequence is
       close -> navigate -> paint and the panel is never left open over the step.
       Reusing go() also means this is not a second navigation path. */
    b.onclick=()=>{const ri=STEPS.findIndex(s=>s.type==='review');
      if(ri>=0){editReturn=false;go(ri);}};
    foot.appendChild(b);
  }
}

/* ---- checkout ----------------------------------------------------------
   Clone of the proven path in lrc-lp2.js: clear -> add (one call) -> redirect.
   Differences, deliberate:
     - clear.js's response IS checked; lrc-lp2.js ignores it and adds anyway.
     - errors surface through toast() inline, not alert().
     - MORE THAN ONE discount code can now be applied. Measured against the live
       shop, because the previous note here was wrong on both counts:
         * a cart holds a LIST of codes, not one. Two applicable codes coexisted
           (backcountryoffer PRODUCT + RunFree SHIPPING, both applicable:true);
         * /checkout?discount=X does not ADD X, it RESETS the list to exactly [X] -
           so the old single-code URL would have destroyed anything else applied;
         * GET /discount/{code} APPENDS to the list and dedupes, and a plain
           /checkout preserves everything accumulated;
         * ?redirect=/cart.js keeps each of those responses at ~370 bytes instead
           of the 965 KB home page.
       Hence: apply every code with /discount/, then navigate to a bare /checkout. */
let submitting=false;
function checkoutItems(){
  const items=[],pl=parseInt(ROOT.getAttribute('data-plan')||'',10);
  CFG.verticals.forEach(v=>v.items.forEach((it,i)=>{
    const n=qty[v.id+'-'+i]||0;
    if(n<=0)return;
    const vid=parseInt(pick(v,it,i).id,10);
    if(!vid)return;
    /* quantity is in UNITS: packs x packQty. A 2-pack at 3 taps is 6 units. */
    const line={id:vid,quantity:n*packQty(v,it)};
    if(pl)line.selling_plan=pl;
    items.push(line);
  }));
  /* every won gift, quantity 1. 'always' and 'choose' gifts are ONE-TIME lines and
     carry no selling_plan - they are zeroed outright by the BXGY. A 'recurring' gift
     is the opposite: it joins the subscription with the same plan as the box, and its
     own recurringCycleLimit-1 code makes only cycle one free. */
  wonGifts().forEach(g=>{
    const gid=parseInt(g.id,10);
    if(!gid)return;
    const line={id:gid,quantity:1};
    if(isRecurring(g)&&pl)line.selling_plan=pl;
    items.push(line);
  });
  return items;
}
/* Every code this box needs, in application order, deduped case-insensitively with
   blanks dropped. The section's BXGY covers the one-time gifts only, so it is omitted
   when the box has won nothing but recurring gifts - that code would have nothing to
   zero. Each recurring gift contributes its own code. */
function checkoutCodes(){
  const won=wonGifts(),out=[],seen={};
  const push=c=>{const t=String(c==null?'':c).trim();if(!t)return;
    const k=t.toLowerCase();if(seen[k])return;seen[k]=1;out.push(t);};
  if(won.some(g=>!isRecurring(g)))push(ROOT.getAttribute('data-gift-code'));
  won.forEach(g=>{if(isRecurring(g))push(g.code);});
  return out;
}
/* Applied one at a time: the code list is server-side cart state and concurrent
   writes are not guaranteed to merge. One failure does not stop the rest. */
function applyCodes(codes){
  let applied=0;
  return codes.reduce((p,c)=>p.then(()=>
    fetch('/discount/'+encodeURIComponent(c)+'?redirect=/cart.js',
      {credentials:'same-origin',headers:{'Accept':'application/json'}})
      .then(r=>{if(r&&r.ok)applied++;})
      .catch(e=>{console.error('[lrc-bb] discount '+c,e);})
  ),Promise.resolve()).then(()=>applied);
}
/* Bare /checkout once the codes are on the cart. The single-code query form is kept
   only as the fallback for when every /discount/ call failed, so a total failure
   degrades to exactly the old behaviour rather than to no discount at all. */
function checkoutUrl(applied,codes){
  if(applied>0||!codes.length)return '/checkout';
  return '/checkout?discount='+encodeURIComponent(codes[0]);
}
function checkout(){
  if(submitting)return;
  const adv=$('#advance'),items=checkoutItems();
  if(!items.length){toast('Your box is empty.');return;}
  const restore=()=>{submitting=false;adv.disabled=false;syncAll();};
  const fail=(msg,err)=>{restore();if(err)console.error('[lrc-bb] checkout',err,err&&err.body);toast(msg);};
  submitting=true;adv.disabled=true;adv.textContent='Working…';
  fetch('/cart/clear.js',{method:'POST',headers:{'Accept':'application/json'}})
    .then(r=>{
      if(!r.ok)return r.text().then(t=>{const e=new Error('cart clear failed: '+r.status);e.body=t;e.stage='clear';throw e;});
      return fetch('/cart/add.js',{method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items:items})});
    })
    .then(r=>{
      if(!r.ok)return r.text().then(t=>{const e=new Error('cart add failed: '+r.status);e.body=t;e.stage='add';throw e;});
      const codes=checkoutCodes();
      return applyCodes(codes).then(applied=>{window.location.href=checkoutUrl(applied,codes);});
    })
    .catch(err=>fail(err&&err.stage==='clear'
      ?'Could not reset your cart. Please try again.'
      :'Something went wrong building your box. Please try again.',err));
}

function openSheet(h){$('#sheetCard').innerHTML=h;$('#sheet').classList.add('open');}
const productSheet=(vi,i)=>{const v=CFG.verticals[vi],it=v.items[i],pq=packQty(v,it);
  const ps=perServK(v,it,i);
  return `<div class="grip"></div><div class="sheet-hd">${sq(it.tint,it.single?'box':v.shape,it.img)}
    <div><h3>${it.n}</h3><span>${money(ps)} / ${v.unit}</span></div></div>
    ${it.d?`<p>${it.d}</p>`:''}<div class="facts">
      <div><span>Servings</span><b>${it.servings}</b></div>
      <div><span>Price per ${v.unit}</span><b>${money(ps)}</b></div>
      ${pq>1?`<div><span>Sold as</span><b>${v.packLabel}</b></div>`:''}
      ${it.upb>1?`<div><span>Counts toward minimum as</span><b>${it.upb}</b></div>`:''}
      ${v.zeroL&&v.zeroV?`<div><span>${v.zeroL}</span><b>${v.zeroV}</b></div>`:''}
    </div>${v.note?`<p class="sheet-note">${v.note}</p>`:''}<button class="sheet-close" data-sheetclose>Got it</button>`;};
const whySheet=vi=>{const v=CFG.verticals[vi];
  return `<div class="grip"></div><div class="sheet-hd"><div><h3>${v.why.h}</h3></div></div>
    <p>${v.why.p}</p><div class="facts">${v.why.facts.map(([a,b])=>`<div><span>${a}</span><b>${b}</b></div>`).join('')}</div>
    <button class="sheet-close" data-sheetclose>Got it</button>`;};

function fly(from){
  const a=from.getBoundingClientRect(),b=$('#cartBtn').getBoundingClientRect();
  const d=document.createElement('div');d.className='lrcbb-fly';
  d.style.left=(a.left+a.width/2-5)+'px';d.style.top=(a.top+a.height/2-5)+'px';
  document.body.appendChild(d);
  d.animate([{transform:'translate(0,0) scale(1)',opacity:1},
    {transform:`translate(${b.left+b.width/2-a.left-a.width/2}px,${b.top+b.height/2-a.top-a.height/2}px) scale(.4)`,opacity:.3}],
    {duration:520,easing:'cubic-bezier(.35,-.2,.5,1)'}).onfinish=()=>d.remove();
}

function wireStep(){
  $$('[data-q]').forEach(b=>b.onclick=()=>{
    const k=b.dataset.q,before=qty[k];
    qty[k]=Math.max(0,qty[k]+ +b.dataset.d);
    if(qty[k]>before)fly(b.closest('.tile').querySelector('.sq'));
    touch(k);
  });
  $$('[data-optv]').forEach(b=>b.onclick=e=>{
    e.stopPropagation();
    const k=b.dataset.optk;
    optSel[k]=+b.dataset.optv;
    touchOpt(k);
  });
  $$('[data-gift]').forEach(g=>g.onclick=()=>{gift=+g.dataset.gift;giftAuto=false;
    $$('[data-gift]').forEach(x=>x.classList.toggle('active',+x.dataset.gift===gift));syncAll();});
  $$('[data-goto]').forEach(g=>g.onclick=()=>{editReturn=g.hasAttribute('data-edit');go(+g.dataset.goto);});
  /* how-it-works rows: reuse the advance button rather than a second path to
     the same place, so any gating it applies applies here too. */
  $$('[data-hiw]').forEach(r=>{
    const fire=()=>$('#advance').click();
    r.onclick=fire;
    r.onkeydown=e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();fire();}};
  });
  $$('[data-info]').forEach(b=>b.onclick=e=>{e.stopPropagation();const[a,c]=b.dataset.info.split('-');openSheet(productSheet(+a,+c));});
  $$('[data-why]').forEach(b=>b.onclick=()=>openSheet(whySheet(+b.dataset.why)));
}
function go(i){dir=i<step?'back':'fwd';step=Math.max(0,Math.min(STEPS.length-1,i));closeCart();render();}
let tT;function toast(m){const h=$('#hint');h.innerHTML=m;h.classList.add('show');clearTimeout(tT);tT=setTimeout(()=>h.classList.remove('show'),2400);}
function openCart(){$('#cartPanel').classList.add('open');$('#veil').classList.add('on');$('#close').classList.add('hidden');}
function closeCart(){$('#cartPanel').classList.remove('open');$('#veil').classList.remove('on');$('#close').classList.remove('hidden');}

/* ---- trigger contract -------------------------------------------------
   [data-open] is bound at DOCUMENT level - and only this attribute - so CTAs
   in sibling sections (header, UGC, reviews sheet, footer) can open the
   builder. Everything else in this IIFE stays scoped to ROOT.
   Optional data-open-step: "review" | "first-gap" | <index> | absent = 0. */
function resolveStep(spec){
  if(spec==null||spec==='')return 0;
  if(spec==='review'){const i=STEPS.findIndex(s=>s.type==='review');return i<0?0:i;}
  if(spec==='first-gap'){
    const v=CFG.verticals.find(v=>minOf(v)>0&&vertUnits(v)<minOf(v));
    if(v){const i=STEPS.findIndex(s=>s.type==='vert'&&s.v.id===v.id);if(i>=0)return i;}
    const f=STEPS.findIndex(s=>s.type==='vert');return f<0?0:f;
  }
  const n=parseInt(spec,10);
  return isNaN(n)?0:Math.max(0,Math.min(STEPS.length-1,n));
}
function openBuilder(spec){
  STEPS=buildSteps();
  step=resolveStep(spec);
  $('#scrim').classList.add('open');
  document.documentElement.style.overflow='hidden';document.body.style.overflow='hidden';
  render();
}
document.addEventListener('click',function(e){
  const t=e.target.closest&&e.target.closest('[data-open]');
  if(!t)return;
  e.preventDefault();
  openBuilder(t.getAttribute('data-open-step'));
});
$('#close').onclick=()=>{$('#scrim').classList.remove('open');closeCart();
  document.documentElement.style.overflow='';document.body.style.overflow='';if(packs()){const m=ROOT.getAttribute('data-close-toast');if(m)toast(m);}};
$('#advance').onclick=()=>{
  if(editReturn){
    /* syncAll() disables the button while a minimum is unmet, but re-check here
       so a keyboard or programmatic activation cannot bypass the gate. */
    const st=STEPS[step];
    if(st&&st.type==='vert'&&vertUnits(st.v)<minOf(st.v))return;
    const ri=STEPS.findIndex(s=>s.type==='review');
    editReturn=false;
    if(ri>=0){go(ri);return;}
  }
  if(step===STEPS.length-1){checkout();return;}
  go(step+1);};
$('#back').onclick=()=>{editReturn=false;go(step-1);};
$('#cartBtn').onclick=()=>$('#cartPanel').classList.contains('open')?closeCart():openCart();
$('#cpClose').onclick=closeCart;$('#veil').onclick=closeCart;
$('#sheetVeil').onclick=()=>$('#sheet').classList.remove('open');
document.addEventListener('click',e=>{if(e.target.closest('[data-sheetclose]'))$('#sheet').classList.remove('open');});
document.addEventListener('keydown',e=>{if(e.key!=='Escape')return;
  if($('#sheet').classList.contains('open'))$('#sheet').classList.remove('open');
  else if($('#cartPanel').classList.contains('open'))closeCart();
  else if($('#scrim').classList.contains('open'))$('#close').click();});

const _cfgPrefill=$('#cfgPrefill'); if(_cfgPrefill)_cfgPrefill.onchange=e=>{CFG.prefill=e.target.checked;resetQty();step=0;render();};
const _cfgProof=$('#cfgProof'); if(_cfgProof)_cfgProof.onchange=e=>{CFG.badges=e.target.checked;render();};
const _cfgIntro=$('#cfgIntro'); if(_cfgIntro)_cfgIntro.onchange=e=>{CFG.showIntro=e.target.checked;step=0;render();};
const _cfg90=$('#cfg90'); if(_cfg90)_cfg90.onchange=e=>{CFG.plan90=e.target.checked;render();};
const _cfgReward=$('#cfgReward'); if(_cfgReward)_cfgReward.onchange=e=>{CFG.reward=e.target.value;gift=null;step=0;render();};

render();
})();

/* ══════════════════════════════════════════════════════════════════════════
   BUY BOX (v21) - merged in from assets/lrc-bbx.js as a SEPARATE IIFE.
   Both IIFEs scope to their own root and bail if it is absent, so either
   surface can be removed without breaking the other:
     builder  -> document.querySelector('.lrc-bb')  ; if (!ROOT) return;
     buy box  -> document.querySelector('.lrc-bbx') ; if (!ROOT) return;
   The buy box CTA carries data-open and lives inside .lrc-bb, so the builder's
   own ROOT-scoped $$('[data-open]') binding picks it up - no extra wiring.
   ══════════════════════════════════════════════════════════════════════════ */
/* LRC Buy Box - script copied VERBATIM from ~/Downloads/lrc-buybox-v21.html
   <script> block (lines 437-722). Changes, and no others:
   (a) every DOM query scoped to the .lrc-bbx root;
   (b) the two dev-panel bindings removed - the panel is a mockup control and
       is not copied, so $('#preset') would be null and throw before paint();
       PRESET_KEY / HEADLINE_KEY hold the values those selects default to.
   (c) three dead things removed, all confirmed orphaned in the reference:
       `document.styleSheets[0];` (no-op), the unstyled class="riskcard"
       (.riskgrid>div does the styling), and the .rvrow .chip CSS rule.
   Data objects stay inline; Phase 5B replaces them with window.LRC_BBX_CFG. */
(function(){
  var ROOT = document.querySelector('.lrc-bbx');
  if (!ROOT) return;
/* ══════════════════════════════════════════════════════
   Theme-editor configuration throughout. Verticals, their
   benefits, free items, study findings, risk lines and
   accordions are all repeatable blocks.
   ══════════════════════════════════════════════════════ */

  /* ---- data ------------------------------------------------------------
     Emitted by sections/lrc-lp2-bb.liquid as window.LRC_BBX_CFG. Shapes are
     exactly what this IIFE already read from the inline mockup objects:
       SLIDES [{u,t,alt}] · VERTS [{name,sw,per,unit,bens[]}]
       HIGHLIGHTS [[ic,val,label]] · STUDY {findings[[v,l,p]],method[[a,b]],cite,caveat}
       ACC [{q,a}] · NUT [{name,serving,rows[[label,value,kind]],ing}]
       PRESETS {<key>:{eyebrow,stackTitle,rows[{ic,label,sub,was,txt}],freeLbl,
                       freeWas,cta,riskCards[[ic,title,sub]],riskLine}}
       HEADLINES {<key>:{h,s}}
     If the config is missing the IIFE bails rather than half-painting. */
  var CFG = window.LRC_BBX_CFG;
  if (!CFG || !CFG.VERTS || !CFG.VERTS.length) return;
  /* inline SVG set for stack rows that have no product behind them */
  const SVG={truck:'<svg viewBox="0 0 24 24"><path d="M2 6.6h11v10.8H2z"/><path d="M13 10h4l3 3v4.4h-7z"/><circle cx="6.5" cy="18.6" r="1.7"/><circle cx="16.5" cy="18.6" r="1.7"/></svg>'};
  var PRESET_KEY = CFG.PRESET_KEY || 'gear', HEADLINE_KEY = CFG.HEADLINE_KEY || 'routine';
  /* static SVG icon map for the study highlights - presentation, not content,
     so it stays inline (same call as UICO for the marquee). */
const ICO={
  pace:'<path d="M13 2 4.5 13.5H11l-1 8.5L19.5 10H13z"/>',
  focus:'<circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="4"/><circle cx="12" cy="12" r="1"/>',
  drop:'<path d="M12 2.7s6 6.3 6 10.3a6 6 0 0 1-12 0c0-4 6-10.3 6-10.3z"/>',
};
  const SLIDES=CFG.SLIDES||[], VERTS=CFG.VERTS, HIGHLIGHTS=CFG.HIGHLIGHTS||[],
        STUDY=CFG.STUDY||{findings:[],method:[],cite:'',caveat:''}, ACC=CFG.ACC||[],
        NUT=CFG.NUT||[], PRESETS=CFG.PRESETS||{}, HEADLINES=CFG.HEADLINES||{};

const $=s=>ROOT.querySelector(s);
let idx=0, vert=0;

/* marquee — two identical sets, translated -50% for a seamless loop */

$('#track').innerHTML=SLIDES.map((a,i)=>`<div class="slide"><div class="art"><img src="${a.u}" alt="${a.alt||''}" width="1100" height="1100" decoding="async" ${i===0?'loading="eager" fetchpriority="high"':'loading="lazy"'} onload="this.classList.add('rdy')" style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover;display:block"></div></div>`).join('');
$('#bbx-dots').innerHTML=SLIDES.map((_,i)=>`<button class="gal-dot${i===0?' on':''}" data-d="${i}"></button>`).join('');
$('#thumbs').innerHTML=SLIDES.map((a,i)=>`<button class="thumb${i===0?' on':''}" data-t="${i}"><div class="art"><img src="${a.t}" alt="" width="160" height="160" decoding="async" loading="lazy" onload="this.classList.add('rdy')" style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover;display:block"></div></button>`).join('');
function go(i){
  idx=(i+SLIDES.length)%SLIDES.length;
  $('#track').style.transform=`translateX(-${idx*100}%)`;
  $('#galCount').textContent=`${idx+1} / ${SLIDES.length}`;
  ROOT.querySelectorAll('.gal-dot').forEach((d,n)=>d.classList.toggle('on',n===idx));
  /* per-slide dot palette, same behaviour as lrc-lp2.js's .lrc-lp-gal--dots-white */
  const galEl=ROOT.querySelector('.gal');
  if(galEl)galEl.classList.toggle('gal--dots-navy',(SLIDES[idx]||{}).dot==='navy');
  ROOT.querySelectorAll('.thumb').forEach((t,n)=>{t.classList.toggle('on',n===idx);
    if(n===idx)t.scrollIntoView({behavior:'smooth',inline:'center',block:'nearest'});});
}
$('#prev').onclick=()=>go(idx-1);$('#next').onclick=()=>go(idx+1);
ROOT.querySelectorAll('[data-d]').forEach(d=>d.onclick=()=>go(+d.dataset.d));
ROOT.querySelectorAll('[data-t]').forEach(t=>t.onclick=()=>go(+t.dataset.t));

$('#studyGrid').innerHTML=HIGHLIGHTS.map(([i,a,b])=>
  `<div><span class="si"><svg viewBox="0 0 24 24">${ICO[i]}</svg></span><b>${a}</b><span>${b}</span></div>`).join('');

$('#shBody').innerHTML=`
  <h4>What it found</h4>
  <div class="findings">${STUDY.findings.map(([n,l,p])=>`
    <div class="finding"><span class="n">${n}<em>${l}</em></span><p>${p}</p></div>`).join('')}</div>
  <h4>How it was run</h4>
  <div class="method">${STUDY.method.map(([a,b])=>`<div><span>${a}</span><b>${b}</b></div>`).join('')}</div>
  <div class="cite">${STUDY.cite}</div>
  <p class="caveat">${STUDY.caveat}</p>`;
/* nutrition modal */
let nut=0;
function paintNut(){
  $('#nutPills').innerHTML=NUT.map((n,i)=>
    `<button class="${i===nut?'on':''}" data-n="${i}">${n.name}</button>`).join('');
  const N=NUT[nut];
  $('#nutPanel').innerHTML=`
    <div class="nfacts">
      <div class="nf-hd"><b>Nutrition facts</b><span>${N.serving}</span></div>
      ${N.rows.map(([a,b,k])=>`<div class="nf-row${k===1?' major':k===2?' sub':''}"><span>${a}</span><b>${b}</b></div>`).join('')}
      <div class="nf-ing"><b>Ingredients</b>${N.ing}</div>
    </div>`;
  ROOT.querySelectorAll('[data-n]').forEach(b=>b.onclick=()=>{nut=+b.dataset.n;paintNut();});
}
paintNut();
ROOT.querySelector('.labellink').onclick=()=>$('#nutMask').classList.add('on');
$('#nutX').onclick=()=>$('#nutMask').classList.remove('on');
$('#nutBg').onclick=()=>$('#nutMask').classList.remove('on');

$('#studyBtn').onclick=()=>$('#mask').classList.add('on');
$('#shX').onclick=()=>$('#mask').classList.remove('on');
$('#maskBg').onclick=()=>$('#mask').classList.remove('on');
document.addEventListener('keydown',e=>{if(e.key==='Escape'){$('#mask').classList.remove('on');$('#nutMask').classList.remove('on');}});

$('#acc').innerHTML=ACC.map(a=>`<details><summary>${a.q}</summary><div class="body">${a.a}</div></details>`).join('');

function paintVerts(){
  $('#verts').innerHTML=VERTS.map((v,i)=>`
    <button class="vert${i===vert?' on':''}" data-v="${i}">
      <span class="sw" style="background:${v.sw}"></span>
      <b>${v.name}</b><i>${v.per}<em> ${v.unit}</em></i>
    </button>`).join('');
  $('#bens').innerHTML=VERTS[vert].bens.map(b=>
    `<li><span class="tick">✓</span><span>${b}</span></li>`).join('');
  /* caret points at the active tile */
  ROOT.querySelector('.benspanel').style.setProperty('--caret',((vert+.5)/VERTS.length*100)+'%');
    ROOT.querySelectorAll('[data-v]').forEach(b=>b.onclick=()=>{vert=+b.dataset.v;paintVerts();});
}

function paint(){
  /* dev panel not copied: use the values its two selects default to. */
  const P=PRESETS[PRESET_KEY], H=HEADLINES[HEADLINE_KEY];
  $('#eyebrow').textContent=P.eyebrow;
  $('#eyebrowWrap').style.display=P.eyebrow?'':'none';
  $('#headline').innerHTML=H.h;
  $('#subhead').innerHTML=H.s;
  $('#stackTitle').textContent=P.stackTitle;
  $('#stackRows').innerHTML=P.rows.map(r=>`
    <div class="srow">
      <span class="thumbic${r.img?'':' is-ico'}">${r.img
        ?`<img src="${r.img}" alt="" width="80" height="80" decoding="async" loading="lazy">`
        :(r.svg?SVG[r.svg]||'':`<em>${r.ic||''}</em>`)}</span>
      <div class="srow-mid"><b>${r.label}</b><span>${r.sub}</span></div>
      <div class="srow-val">${r.was?`<s>${r.was}</s>`:''}<b>${r.txt||'Free'}</b></div>
    </div>`).join('');
  $('#freeLbl').textContent=P.freeLbl;
  $('#freeWas').textContent=P.freeWas;
  $('#ctaBtn').textContent=P.cta;
  $('#riskCards').innerHTML=P.riskCards.map(([i,a,b])=>
    `<div><span class="ic">${i}</span><div><b>${a}</b><span>${b}</span></div></div>`).join('');
  $('#riskLine').innerHTML=P.riskLine;
}
paintVerts();paint();
/* initial slide's palette */
{const g0=ROOT.querySelector('.gal');if(g0)g0.classList.toggle('gal--dots-navy',(SLIDES[0]||{}).dot==='navy');}
/* cached images can complete before the onload handler observes them; sweep once
   so the fade can never strand one at opacity 0 (Phase 3A.2 pattern). */
[...ROOT.querySelectorAll('.art img')].forEach(im=>{if(im.complete&&im.naturalWidth)im.classList.add('rdy');});

/* ── asymmetric sticky ──────────────────────────────────────────────
   The left column only pins usefully if it fits the viewport, so the
   gallery is capped to whatever height the rest of the column leaves.
   It stays square — we cap width, so nothing is cropped. */
const HEADER_GAP=78, BOTTOM_GAP=24;
function syncSticky(){
  const col=ROOT.querySelector('#leftCol');
  const gal=ROOT.querySelector('.gal');
  if(!col||!gal) return;

  /* the gallery is never capped: it is a block child of #leftCol and fills the
     column, so it stays aligned with the nutrition button and study badge under
     it. A column taller than the viewport is handled by the sticky offset
     instead of by shrinking the image. */
  gal.style.maxWidth='';

  if(window.innerWidth<940){
    col.style.position=''; col.style.top=''; col.style.bottom=''; return;
  }

  /* Fits the viewport -> HEADER_GAP, exactly as before.
     Taller than the viewport -> a negative top, so the column scrolls up until
     its bottom edge is visible and pins there. Clamped so it can never travel
     further than its own height. */
  const colH=col.offsetHeight;
  let top=Math.min(HEADER_GAP, window.innerHeight-colH-BOTTOM_GAP);
  if(top<-colH) top=-colH;

  col.style.position='sticky';
  col.style.top=Math.round(top)+'px';
  col.style.bottom='auto';
}
syncSticky();
window.addEventListener('resize',syncSticky,{passive:true});
window.addEventListener('load',syncSticky);
if('ResizeObserver' in window){
  const ro=new ResizeObserver(()=>{clearTimeout(window.__st);window.__st=setTimeout(syncSticky,60);});
  ro.observe(ROOT.querySelector('#leftCol'));
}
})();
